export default {
    nl: {
        intro: {
            subtitle: 'Design sprint',
            title: 'Sprintje trekken.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/design-sprint/hero.jpg',
        },
        type: 'Design sprint',
        title: 'Design Sprint uitgelegd: snel en tastbaar resultaat',
        description:
            'Met een Design Sprint helpen we onze klanten in korte tijd met het ontwerpen, prototypen en testen van ideeën. Iets voor jouw bedrijf?',
        content: [
            {
                type: 'text',
                title: 'Design sprint',
                content: `
                    Een Design Sprint is een dynamische methode waarbij ideeën worden omgezet in tastbare wireframes en prototypes in een kwestie van een paar dagen. Deze methode is ontwikkeld door Google Ventures en helpt het team om complexe uitdagingen aan te gaan en innovatie te stimuleren.
                    <br><br>
                    Binnen 23G bruist ons team van talent en ervaring, gericht op het faciliteren van Design Sprints. Wij omarmen de kracht van samenwerking en betrekken alle relevante stakeholders in elk stadium. Of je nu een start-up bent met een revolutionair idee, een gevestigd bedrijf dat optimalisatie zoekt voor hun product of een organisatie die een nieuwe strategie wil ontwikkelen, wij helpen je graag je doel te bereiken.
                `,
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/research.webp',
                ],
                imageWidth: 817,
            },
            {
                type: 'text',
                title: 'Fases van onze design sprint',
                content: `
                    Onze Design Sprints bestaan uit vijf fasen: begrijpen, schetsen, beslissen, prototypen en valideren. In de begrijpen-fase duiken we diep in de problematiek, analyseren we gebruikersinzichten en stellen we de doelstellingen vast. Vervolgens gaan we over naar de schetsfase, waarin we met behulp van diverse brainstormtechnieken zoveel mogelijk ideeën genereren. Na de selectie van top ideeën verfijnen we deze tot beloftevolle concepten in de beslissen-fase.
                    <br><br>
                    Hierna begint het echte werk. We creëren een prototype dat de kernfunctionaliteiten van het product weergeeft. Het kan een klikbaar digitaal prototype zijn of zelfs een fysiek model, afhankelijk van het type product. Ten slotte valideren we het prototype door middel van gebruikerstests en feedbacksessies. Zo kijken we bij digitale prototypes vaak of er een logische customer journey wordt afgelegd en toetsen we de gebruikerservaring aan de hand van UX research. Op basis van de resultaten kunnen we het concept verder aanscherpen en optimaliseren.
                `,
            },
            {
                type: 'gallery',
                items: [
                    {
                        title: 'De situatie begrijpen',
                        content:
                            'Deze dag gebruiken wij om de uitdaging te bespreken en wat het uiteindelijke doel is.',
                        image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/design-sprint/design-sprint-1.webp',
                        imageHeight: 100,
                    },
                    {
                        title: 'Diverge',
                        content:
                            'Dag twee staat in het teken van inspiratie en het bedenken van mogelijke oplossingen.',
                        image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/design-sprint/design-sprint-2.webp',
                        imageHeight: 146,
                    },
                    {
                        title: 'Scope bepalen',
                        content:
                            'Op dag drie beslissen we met welke oplossing we verder gaan in het proces.',
                        image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/design-sprint/design-sprint-3.webp',
                        imageHeight: 137,
                    },
                    {
                        title: 'Prototype',
                        content:
                            'Gezamelijk selecteren we de meest kansrijke oplossing en werken we toe naar een prototype.',
                        image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/design-sprint/design-sprint-4.webp',
                        imageHeight: 146,
                    },
                    {
                        title: 'Test',
                        content:
                            'Deze dag staat in het teken van testen. We betrekken stakeholders om tot inzichten te komen over het prototype.',
                        image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/design-sprint/design-sprint-5.webp',
                        imageHeight: 161,
                    },
                ],
            },
            {
                type: 'text',
                title: 'Flexibiliteit en maatwerk in Design Sprints',
                content: `
                    Elke klant is uniek en heeft andere behoeften. Dit snappen we bij 23G als geen ander. Daarom worden onze Design Sprints flexibel afgestemd op de vraag van de klant. Onze Design Sprints zijn modulair en aanpasbaar, variërend in duur en met de mogelijkheid om bepaalde stappen over te slaan. Op deze manier sluiten wij aan op alle specifieke behoeften en doelen van de klant.
                    <br><br>
                    Onze toewijding is om een op maat gemaakt traject te leveren dat synchroon loopt met de ambities en verwachtingen van onze klanten. Dit doen we terwijl we de hoogste normen van innovatie en kwaliteit in UI/UX design hanteren.
                `,
            },
            {
                type: 'quote',
                content:
                    'Een design sprint: de turbo voor ideeën, die verandering en innovatie in enkele dagen mogelijk maakt',
            },
            {
                type: 'case',
                case: 'dnzb',
            },
        ],
        related_services: ['ui-ux-design', 'front-end-development', 'visual-design'],
        contact: {
            title: '',
            employee: 'tobias',
        },
    },
    en: {},
};
